<template>
  <div class="news">
    <Banner :banner="banner" />
    <div class="container">
      <div class="detail">
        <div class="title">{{news.TITLE}}</div>
        <div class="date">{{news.SHOWTIME.slice(0,10)}}</div>
        <div class="content" v-html="news.CONTENT"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
export default {
  components: {
    Banner
  },
  data(){
    return{
      banner:{
        title:'企业动态',
        img:'/images/newsbanner.jpg'
      },
      news:{
        TITLE:'',
        SHOWTIME:''
      }
    }
  },
  created(){
    this.getnews()
  },
  methods: {
    getnews(){
      this.$$axios.get('/php/new.php', {
        params: {
          nid: this.$route.params.id
        }
      })
      .then(res=>{
        this.news=res.data
      })
      .catch(error=>{
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
.news{
}
.news .container{
  background-color: #f5f5f5;
  padding: 100px;
}
.news .container .detail{
  background-color: #fff;
  padding: 100px;
}
.news .container .detail .title{
  font-size: 28px;
  color: #333;
  line-height: 68px;
  text-align: center;
}
.news .container .detail .date{
  font-size: 14px;
  color: #666;
  line-height: 30px;
  text-align: center;
}
.news .container .detail .content{
  padding: 60px 0;
}
@media(max-width: 768px){
  .news .container{
    padding: 50px 20px;
  }
  .news .container .detail{
    padding: 50px 20px;
  }
  .news .container .detail .title{
    font-size: 20px;
    line-height: 30px;
  }
}
</style>


